import React from "react"

import { createIcon } from "@chakra-ui/react"

export const SuplifulIcon = createIcon({
  displayName: "Supliful",
  viewBox: "0 0 24 32",
  path: (
    <>
      <path
        fill="currentColor"
        d="M23.718 11.727c-.092-3.172-1.392-6.179-3.621-8.373C17.868 1.16 14.89-.044 11.805.001 5.421.094.234 5.497.222 12.067c-.008 2.484.73 4.91 2.116 6.944a.354.354 0 01-.101.495.33.33 0 01-.175.051H.566a.33.33 0 00-.243.107.35.35 0 00-.095.254C.32 23.09 1.62 26.096 3.85 28.29c2.229 2.193 5.206 3.397 8.29 3.352 6.385-.092 11.572-5.495 11.584-12.066a12.267 12.267 0 00-2.118-6.944.355.355 0 01.102-.497.332.332 0 01.176-.05h1.495a.33.33 0 00.243-.105.35.35 0 00.096-.252z"
      />
      <path
        fill="#FFFFFF"
        d="M6.6 15.481l7.219-7.425a.335.335 0 01.369-.075.342.342 0 01.151.129.355.355 0 01.057.193v6.872c0 .092.036.181.1.246.063.066.149.102.238.102h2.708c.066 0 .132.02.187.059a.357.357 0 01.051.535l-7.218 7.425a.336.336 0 01-.369.076.34.34 0 01-.152-.128.356.356 0 01-.057-.193v-6.873a.353.353 0 00-.099-.247.334.334 0 00-.24-.102H6.84a.332.332 0 01-.188-.058.357.357 0 01-.051-.535z"
      />
    </>
  ),
})

export const SuplifulMonoIcon = createIcon({
  displayName: "SuplifulMono",
  viewBox: "0 0 24 32",
  path: (
    <>
      <path
        fill="#000000"
        d="M23.718 11.727c-.092-3.172-1.392-6.179-3.621-8.373C17.868 1.16 14.89-.044 11.805.001 5.421.094.234 5.497.222 12.067c-.008 2.484.73 4.91 2.116 6.944a.354.354 0 01-.101.495.33.33 0 01-.175.051H.566a.33.33 0 00-.243.107.35.35 0 00-.095.254C.32 23.09 1.62 26.096 3.85 28.29c2.229 2.193 5.206 3.397 8.29 3.352 6.385-.092 11.572-5.495 11.584-12.066a12.267 12.267 0 00-2.118-6.944.355.355 0 01.102-.497.332.332 0 01.176-.05h1.495a.33.33 0 00.243-.105.35.35 0 00.096-.252z"
      />
      <path
        fill="#FFFFFF"
        d="M6.6 15.481l7.219-7.425a.335.335 0 01.369-.075.342.342 0 01.151.129.355.355 0 01.057.193v6.872c0 .092.036.181.1.246.063.066.149.102.238.102h2.708c.066 0 .132.02.187.059a.357.357 0 01.051.535l-7.218 7.425a.336.336 0 01-.369.076.34.34 0 01-.152-.128.356.356 0 01-.057-.193v-6.873a.353.353 0 00-.099-.247.334.334 0 00-.24-.102H6.84a.332.332 0 01-.188-.058.357.357 0 01-.051-.535z"
      />
    </>
  ),
})
